





















































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class DanceWorld extends Vue {
  @Prop()
  private msg!: string;
  videoId = '6gbbGQ26OGc';
}

